import { render, staticRenderFns } from "./InviteDetailPopup.vue?vue&type=template&id=2bb6947e&scoped=true&"
import script from "./InviteDetailPopup.vue?vue&type=script&lang=js&"
export * from "./InviteDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./InviteDetailPopup.vue?vue&type=style&index=0&id=2bb6947e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6947e",
  null
  
)

export default component.exports